import ItemsPage from './SharedItems/ItemsPage'
import * as React from 'react'

function ItemPageStorage() {
  return <ItemsPage category={'Researcher'} />
}

export default ItemPageStorage
